import { filterObjectStore, queryFilter } from 'Redux/Query';

export const getStatementTemplates = (state, filter = null) => {
    if(filter === null) {
        filter = queryFilter({sorting: { by: 'createdAt', order: 'DESC' }})
    }

    return filterObjectStore(state.statementTemplate.statementTemplate.entries, filter);
};
